import { render, staticRenderFns } from "./addressBook.vue?vue&type=template&id=1cc165df&"
import script from "./addressBook.vue?vue&type=script&lang=ts&"
export * from "./addressBook.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports